import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';
import type { ClientProvider } from '../types/client';

interface RawProvider {
  id: number;
  name: string;
  role: string;
  description: string | null;
  avatarUrl: string | null;
  active: boolean;
  nextAvailableSlot: string | null;
}

function mapProvider(raw: RawProvider): ClientProvider {
  return {
    id: raw.id,
    displayName: raw.name,
    bio: raw.description,
    photoUrl: raw.avatarUrl,
    active: raw.active,
    defaultBookingMode: 'FREE_AUTO_CONFIRM',
  };
}

export const clientProvidersApi = {
  getList: async (): Promise<ClientProvider[]> => {
    const res = await apiClient.get<ApiResponse<RawProvider[]>>(API_PATHS.CLIENT_PROVIDERS);
    return res.data.data.map(mapProvider);
  },
};
